/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { TFunction } from 'i18next';

import { RJSFValidationError } from '@rjsf/utils';

export const applyI18nToRJSFErrors = (t: TFunction) => (errors: RJSFValidationError[]) => {
  return errors.map(error => {
    if (error.name === 'type') {
      error.message = t(`details.parameters.errors.${error.name}.${error.params.type}`, error.message, {
        ...error.params,
      });
    } else {
      error.message = t(`details.parameters.errors.${error.name}`, error.message, { ...error.params });
    }
    return error;
  });
};
